import App from './App.svelte';
import { loadAsset } from './lib/assets.js';

loadAsset('pdfjsLib');
const app = new App({
  target: document.body,
});

export default app;
